import cogoToast from "cogo-toast"
import React, { useEffect, useState } from "react"
// import NcPlayIcon2 from "components/NcPlayIcon2/NcPlayIcon2"
// import cogoToast from "cogo-toast"

const ViewerScreenContainer = ({ channelId, live }) => {
  const [liveVideoId, setLiveVideoId] = useState(null);

  useEffect(() => {
    const fetchLive = async () => {
      try {
        const res = await fetch(
          `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${channelId}&eventType=live&type=video&key=AIzaSyAQi-0PDHi5rIJ6RJl7fLEqR7ML-NI5DUo`
        );
        const data = await res.json();
        if (data.items && data.items.length > 0) {
          cogoToast.info("Live gotowy")
          setLiveVideoId(data.items[0].id.videoId);
        } else {
          setLiveVideoId(null);
        }
      } catch (err) {
        console.error(err);
        setLiveVideoId(null);
      }
    };

    fetchLive();
    const interval = setInterval(fetchLive, 60000); // co 60s odświeżenie
    return () => clearInterval(interval);
  }, [channelId]);

  return (
    <div style={{ width: "100%", height: "70%", marginTop:"20px" }}>
      {liveVideoId ? (
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${liveVideoId}?autoplay=1`}
          frameBorder="0"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
        ></iframe>
      ) : (
        <video
          style={{ width: "100%", height: "100%" }}
          controls
          src={live[0]?.default_video}
          poster="
https://respublica.publit.io/file/LIVE-9-00.jpg"
        ></video>
      )}
    </div>
  );
};

export default ViewerScreenContainer;
